<script lang="ts">
  import { onMount } from 'svelte'

  import { PUBLIC_BUTANE_API_BASE_URL } from '$env/static/public'

  let { children } = $props()
  const apiBaseUrl = PUBLIC_BUTANE_API_BASE_URL.replace(/\/$/, '')

  onMount(() => {
    void import('$lib/api-logger.client')
  })
</script>

<svelte:head>
  {#if apiBaseUrl}
    <link rel="preconnect" href={apiBaseUrl} />
    <link rel="dns-prefetch" href={apiBaseUrl} />
  {/if}
</svelte:head>

{@render children()}
